import React from 'react'
import PropTypes from 'prop-types'
import { omit } from 'lodash'

import { ExtendedDropzoneContext } from 'components/Upload/ExtendedDropzone/ExtendedDropzone'
import Button from 'components/UI/Button'

const AddAttachmentButton = ({ children, className, onClick, buttonProps = {}, cameraMode = false }) => {
    return (
        <ExtendedDropzoneContext.Consumer>
            {(dropzoneContext) => (
                <Button
                    type="button"
                    className={className}
                    trackName={cameraMode ? 'addAttachmentWithCameraMode' : 'addAttachment'}
                    onClick={(e) => {
                        e.persist()
                        dropzoneContext.setCamera(cameraMode)
                        setTimeout(() => {
                            dropzoneContext.open()
                            onClick && onClick(e)
                        }, 20)
                    }}
                    {...buttonProps}
                >
                    {children}
                </Button>
            )}
        </ExtendedDropzoneContext.Consumer>
    )
}

AddAttachmentButton.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    cameraMode: PropTypes.bool,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    buttonProps: PropTypes.shape(omit(Button.propTypes, ['trackName'])),
}

export default AddAttachmentButton
